"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cachedPromise = void 0;
function cachedPromise(factory, lifetime) {
    if (lifetime <= 0) {
        return factory;
    }
    let cache = null;
    const reset = () => {
        cache = null;
    };
    return function () {
        if (!cache) {
            cache = factory.call(this);
            cache
                .then(() => {
                setTimeout(reset, lifetime);
            })
                .catch(reset);
        }
        return cache;
    };
}
exports.cachedPromise = cachedPromise;
